// extracted by mini-css-extract-plugin
export default {"container":"UploadStudentUserReview_container__VuTbq","remark":"UploadStudentUserReview_remark__0n1pd","btn":"UploadStudentUserReview_btn__ePR1X"};